<div class="form-card">
  <div class="card-header">
    <div class="card-header-icon vendas-icon">
      <i class="pi pi-inbox"></i>
    </div>
    <span class="card-header-title">{{ 'relatorio-itens-vendidos.texts.relatorio_de_itens_vendidos' | translate }}</span>
  </div>
  <div class="card-content">
    <div class="form-grid">

      <!-- SELECIONAR NOTA -->
      <div class="form-field full">
        <label class="form-label">{{ 'relatorio-itens-vendidos.labels.selecionar_nota' | translate }}</label>
        <p-dropdown [options]="notas" [(ngModel)]="selectedNota" optionLabel="emissao"
          [filter]="true" [filterBy]="'codigoNota,emissao'" [showClear]="true"
          [placeholder]="('relatorio-itens-vendidos.labels.selecionar_nota' | translate)"
          (onFilter)="onNotasFilter($event)" [loading]="loadingNotas" appendTo="body" styleClass="w-full">

          <ng-template pTemplate="header">
            <div class="grid font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.codigo_da_nota' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.emissao' | translate }}</div>
            </div>
          </ng-template>

          <ng-template let-nota pTemplate="item">
            <div class="grid px-2 py-1 text-sm">
              <div class="col-2">{{ nota.codigoNota }}</div>
              <div class="col-2">{{ formatarDataEHora(nota.emissao) }}</div>
            </div>
          </ng-template>

          <ng-template pTemplate="selectedItem" let-nota>
            {{ nota.codigoNota + ' - ' + formatarDataEHora(nota.emissao) }}
          </ng-template>

          <ng-template pTemplate="empty">
            <div class="p-2 text-center text-500">{{ 'relatorio-itens-vendidos.labels.nenhum_cliente_encontrado' | translate }}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- SELECIONAR ITEM -->
      <div class="form-field full">
        <label class="form-label">{{ 'relatorio-itens-vendidos.labels.selecionar_produto' | translate }}</label>
        <p-dropdown [options]="produtos" [(ngModel)]="selectedProduto" optionLabel="nome"
          [filter]="true" [filterBy]="'nome,grupo.nome,subGrupo.nome,marca.nome,codigoItem'" [showClear]="true"
          [placeholder]="('relatorio-itens-vendidos.placeholders.selecionar_produto' | translate)"
          (onFilter)="onProdutosFilter($event)" [loading]="loadingProdutos" appendTo="body" styleClass="w-full">

          <ng-template pTemplate="header">
            <div class="flex font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
              <div class="mr-4" style="flex: 0 0 50px;">{{ 'relatorio-itens-vendidos.table_headers.imagem' | translate }}</div>
              <div class="mr-2" style="flex: 0 0 100px;">{{ 'relatorio-itens-vendidos.table_headers.codigo' | translate }}</div>
              <div class="mr-2" style="flex: 1;">{{ 'relatorio-itens-vendidos.table_headers.nome' | translate }}</div>
              <div class="mr-2" style="flex: 1;">{{ 'relatorio-itens-vendidos.table_headers.grupo' | translate }}</div>
              <div class="mr-2" style="flex: 1;">{{ 'relatorio-itens-vendidos.table_headers.marca' | translate }}</div>
              <div class="mr-2" style="flex: 1;">{{ 'relatorio-itens-vendidos.table_headers.preco_custo' | translate }}</div>
              <div class="mr-2" style="flex: 1;">{{ 'relatorio-itens-vendidos.table_headers.preco_venda' | translate }}</div>
            </div>
          </ng-template>

          <ng-template let-produto pTemplate="item">
            <div class="flex px-2 py-1 text-sm justify-content-center align-items-center">
              <div class="mr-4" style="flex: 0 0 50px;">
                <img class="product-image" [src]="env.imgHost + '/' + idEmpresa + '/item/' + produto.imagem"
                  [alt]="produto.nome" (error)="onImageError($event)" />
              </div>
              <div class="mr-2" style="flex: 0 0 100px;">{{ produto.codigoItem }}</div>
              <div class="mr-2" style="flex: 1;">{{ produto.nome }}</div>
              <div class="mr-2" style="flex: 1;">{{ produto.grupo?.nome || '-' }}</div>
              <div class="mr-2" style="flex: 1;">{{ produto.subGrupo?.nome || '-' }}</div>
              <div class="mr-2" style="flex: 1;">{{ formatarValorMonetario(produto.custo) }}</div>
              <div class="mr-2" style="flex: 1;">{{ formatarValorMonetario(produto.precoDeVenda) }}</div>
            </div>
          </ng-template>

          <ng-template pTemplate="empty">
            <div class="p-2 text-center text-500">{{ 'relatorio-itens-vendidos.spans.nenhum_produto_encontrado' | translate }}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Categoria | Subcategoria | Marca -->
      <div class="form-field third">
        <label class="form-label">{{ 'relatorio-itens-vendidos.labels.selecionar_categoria' | translate }}</label>
        <app-select-grupo [(ngModel)]="selectedGrupo"></app-select-grupo>
      </div>

      <div class="form-field third">
        <label class="form-label">{{ 'relatorio-itens-vendidos.labels.selecionar_subcategoria' | translate }}</label>
        <app-select-subgrupo [grupoId]="selectedGrupo?.id" [(ngModel)]="selectedSubGrupo"></app-select-subgrupo>
      </div>

      <div class="form-field third">
        <label class="form-label">{{ 'relatorio-itens-vendidos.labels.selecionar_marca' | translate }}</label>
        <app-select-marca [(ngModel)]="selectedMarca"></app-select-marca>
      </div>

      <!-- SELECIONAR CLIENTE -->
      <div class="form-field full">
        <label class="form-label">{{ 'relatorio-itens-vendidos.labels.selecionar_cliente' | translate }}</label>
        <p-dropdown [options]="clientes" [(ngModel)]="selectedCliente" optionLabel="nome"
          [filter]="true" [filterBy]="'nome,fantasia,telefone,ci,ruc,nomeCidade,codigoPessoa'" [showClear]="true"
          [placeholder]="('relatorio-itens-vendidos.placeholders.selecionar_cliente' | translate)"
          (onFilter)="onClientesFilter($event)" [loading]="loadingClientes" appendTo="body" styleClass="w-full">

          <ng-template pTemplate="header">
            <div class="grid font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
              <div class="col-1">{{ 'relatorio-itens-vendidos.table_headers.codigo' | translate }}</div>
              <div class="col-3">{{ 'relatorio-itens-vendidos.table_headers.nome' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.nome_fantasia' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.telefone' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.ci' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.ruc' | translate }}</div>
            </div>
          </ng-template>

          <ng-template let-cliente pTemplate="item">
            <div class="grid px-2 py-1 text-sm">
              <div class="col-1">{{ cliente.codigoPessoa }}</div>
              <div class="col-3">{{ cliente.nome }}</div>
              <div class="col-2">{{ cliente.fantasia }}</div>
              <div class="col-2">{{ cliente.telefone }}</div>
              <div class="col-2">{{ cliente.ci }}</div>
              <div class="col-2">{{ cliente.ruc }}</div>
            </div>
          </ng-template>

          <ng-template pTemplate="empty">
            <div class="p-2 text-center text-500">{{ 'relatorio-itens-vendidos.spans.nenhum_fornecedor_encontrado' | translate }}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- SELECIONAR FORNECEDOR -->
      <div class="form-field full">
        <label class="form-label">{{ 'relatorio-itens-vendidos.labels.selecionar_fornecedor' | translate }}</label>
        <p-dropdown [options]="fornecedores" [(ngModel)]="selectedFornecedor" optionLabel="nome"
          [filter]="true" [filterBy]="'nome,fantasia,telefone,ci,ruc,nomeCidade,codigoPessoa'" [showClear]="true"
          [placeholder]="('relatorio-itens-vendidos.placeholders.selecionar_fornecedor' | translate)"
          (onFilter)="onFornecedorFilter($event)" [loading]="loadingFornecedores" appendTo="body" styleClass="w-full">

          <ng-template pTemplate="header">
            <div class="grid font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
              <div class="col-1">{{ 'relatorio-itens-vendidos.table_headers.codigo' | translate }}</div>
              <div class="col-3">{{ 'relatorio-itens-vendidos.table_headers.nome' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.nome_fantasia' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.telefone' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.ci' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.ruc' | translate }}</div>
            </div>
          </ng-template>

          <ng-template let-fornecedor pTemplate="item">
            <div class="grid px-2 py-1 text-sm">
              <div class="col-1">{{ fornecedor.codigoPessoa }}</div>
              <div class="col-3">{{ fornecedor.nome }}</div>
              <div class="col-2">{{ fornecedor.fantasia }}</div>
              <div class="col-2">{{ fornecedor.telefone }}</div>
              <div class="col-2">{{ fornecedor.ci }}</div>
              <div class="col-2">{{ fornecedor.ruc }}</div>
            </div>
          </ng-template>

          <ng-template pTemplate="empty">
            <div class="p-2 text-center text-500">{{ 'relatorio-itens-vendidos.spans.nenhum_fornecedor_encontrado' | translate }}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- SELECIONAR VENDEDOR -->
      <div class="form-field full">
        <label class="form-label">{{ 'relatorio-itens-vendidos.labels.selecionar_vendedor' | translate }}</label>
        <p-dropdown [options]="vendedores" [(ngModel)]="selectedVendedor" optionLabel="nome"
          [filter]="true" [filterBy]="'nome,fantasia,telefone,ci,ruc,nomeCidade,codigoPessoa'" [showClear]="true"
          [placeholder]="('relatorio-itens-vendidos.placeholders.selecionar_vendedor' | translate)"
          (onFilter)="onVendedorFilter($event)" [loading]="loadingVendedores" appendTo="body" styleClass="w-full">

          <ng-template pTemplate="header">
            <div class="grid font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
              <div class="col-1">{{ 'relatorio-itens-vendidos.table_headers.codigo' | translate }}</div>
              <div class="col-3">{{ 'relatorio-itens-vendidos.table_headers.nome' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.nome_fantasia' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.telefone' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.ci' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.ruc' | translate }}</div>
            </div>
          </ng-template>

          <ng-template let-vendedor pTemplate="item">
            <div class="grid px-2 py-1 text-sm">
              <div class="col-1">{{ vendedor.codigoPessoa }}</div>
              <div class="col-3">{{ vendedor.nome }}</div>
              <div class="col-2">{{ vendedor.fantasia }}</div>
              <div class="col-2">{{ vendedor.telefone }}</div>
              <div class="col-2">{{ vendedor.ci }}</div>
              <div class="col-2">{{ vendedor.ruc }}</div>
            </div>
          </ng-template>

          <ng-template pTemplate="empty">
            <div class="p-2 text-center text-500">{{ 'relatorio-itens-vendidos.spans.nenhum_vendedor_encontrado' | translate }}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Agrupar | Ordenação | Período -->
      <div class="form-field col-4 m-0">
        <label class="form-label">{{ 'relatorio-itens-vendidos.labels.selecione_o_agrupamento' | translate }}</label>
        <p-dropdown [options]="agruparOptions" optionLabel="label" optionValue="value"
          placeholder="{{ 'relatorio-itens-vendidos.placeholders.selecione' | translate }}" [(ngModel)]="params.agrupar"
          [filter]="true" filterBy="label" appendTo="body" styleClass="w-full"></p-dropdown>
      </div>

      <!-- Ordenação -->
      <div class="form-field col-4">
        <label class="form-label">{{ 'relatorio-itens-vendidos.labels.selecione_a_ordenacao' | translate }}</label>
        <p-dropdown [options]="ordenacaoOptions" optionLabel="label" optionValue="value"
          placeholder="{{ 'relatorio-itens-vendidos.placeholders.selecione_a_ordenacao' | translate }}"
          [(ngModel)]="selectedOrdenacao" [showClear]="true"
          [filter]="true" filterBy="label" appendTo="body" styleClass="w-full"></p-dropdown>
      </div>

      <!-- Período (componente compartilhado do dashboard) -->
      <div class="form-field col-3">
        <label class="form-label">{{ 'periodos_relatorio.selecione_o_periodo' | translate }}</label>
        <app-periodo-filtro modo="avancado" [valorPadrao]="'today'" [persistir]="true" [opcoes]="opcoesPeriodo" [textoExibicao]="periodoTexto"
          styleClass="w-full periodo-filtro-neutro" (periodoChanged)="onPeriodoChanged($event)"></app-periodo-filtro>
      </div>

      <!-- Botão Emitir -->
      <div class="form-field full">
        <div class="actions-container">
          <button pButton type="button" [disabled]="emitindoRelatorio" class="btn-primary"
            label="{{ 'relatorio-itens-vendidos.buttons.emitir_relatorio' | translate }}" icon="pi pi-file-pdf"
            (click)="emitirRelatorio()">
          </button>
          <app-loading-dialog [visible]="emitindoRelatorio"
            title="{{ 'relatorios.texts.gerando_relatorio' | translate }}" />
        </div>
      </div>

    </div>
  </div>
</div>

<p-toast></p-toast>
